import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getRegion } from 'utils/Region';
import Metrics from 'services/metrics';
import { converter } from 'helpers/converter';
import { creditCardPayway } from 'components/user/MyAccountSelector';
import './styles.scss';
import { getTranslation } from 'utils/getTranslation';
import { UserContext } from 'providers/user.provider';
import { isKidProfile } from 'containers/NewSearchPage/utils/isKidProfile';
import { useProfiles } from 'containers/ProfileManager/hooks/useProfiles';

export const OpcionMenuAdmin = ({ onClose }) => {
  const { profilesEnable } = useProfiles();
  const store = useSelector(state => state);
  const { isAdmin } = useSelector(state => state.user);
  const translations = useSelector(state => state.translations);
  const translationsMetadata = useSelector(
    state => JSON.parse(state?.metadata?.translations)?.language?.[getRegion()],
  );
  const perfiles = useSelector(
    state => state.profilesManager.profilesInfo?.members,
  );
  const { gamification_id } = useSelector(state => state.user);

  const { logout } = useContext(UserContext);

  const isKids = isKidProfile(perfiles, gamification_id);
  //----------------------------------
  const suscription = `/${getRegion()}/home/user?micuentafull#micuentavtc`;
  const payment = `/${getRegion()}/home/user?micuentafull#micuentamodificarmediodepago`;
  const myProfile = `/${getRegion()}/home/user?micuentafull#micuentamodifyuser`;
  const count = `/${getRegion()}/home/user?micuentafull#micuentadevices`;
  const parental = `/${getRegion()}/home/user?micuentafull#micuentacontrolpin`;
  const history = `/${getRegion()}/home/user?micuentafull#micuentahistorial`;
  const preference = `/${getRegion()}/home/preference?preference&amp;info=pref`;

  const showPaymentOption = creditCardPayway(store);

  // functiones

  const sendMetric = label => {
    Metrics.newEvent({
      eventCategory: 'Mi Cuenta',
      eventAction: 'Click',
      eventLabel: label,
    });
    onClose && onClose();
  };

  const handleLogout = () => {
    onClose && onClose();
    logout();
    localStorage.removeItem('epgVersion');
    localStorage.removeItem('epgMenu');
    localStorage.removeItem('epgLineUp');
    localStorage.removeItem('epgChannelGrid');
    localStorage.removeItem('isEmailRegister');
    localStorage.removeItem('getUserInfo');
  };

  return (
    <>
      {(!isKids && profilesEnable) && <hr className="menu-avatar-desktop__opt__admin__hr" />}
      <div className="menu-avatar-container-option-my-account">
        {isAdmin && (
          <>
            <li className="menu-avatar-desktop__opt__admin">
              <NavLink
                to={suscription}
                onClick={() => sendMetric('Suscripción')}
              >
                  {converter.convertApaUnicode(
                  translationsMetadata,
                  'suscription',
                  'Suscripción',
                )}{' '}
              </NavLink>
            </li>
            <>
              {getRegion() === 'mexico' && showPaymentOption && (
                <li className="menu-avatar-desktop__opt__admin">
                  <NavLink
                    className=""
                    to={payment}
                    onClick={() => sendMetric('Medio de Pago')}
                  >
                    {converter.convertApaUnicode(
                      translationsMetadata,
                      'payment_selection_lbl',
                      'Medio de Pago',
                    )}
                  </NavLink>
                </li>
              )}
            </>
            <li className="menu-avatar-desktop__opt__admin">
              <NavLink to={myProfile} onClick={() => sendMetric('Mi perfil')}>
                {converter.convertApaUnicode(
                  translationsMetadata,
                  'my_profile',
                  'Mi perfil',
                )}
              </NavLink>
            </li>
            <li className="menu-avatar-desktop__opt__admin">
              <NavLink
                to={count}
                onClick={() => sendMetric('Mis dispositivos')}
              >
                {converter.convertApaUnicode(
                  translationsMetadata,
                  'my_devices',
                  'Mis dispositivos',
                )}
              </NavLink>
            </li>
            <li className="menu-avatar-desktop__opt__admin">
              <NavLink
                to={parental}
                onClick={() => sendMetric('PIN de Protección')}
              >
                {converter.convertApaUnicode(
                  translationsMetadata,
                  'access_code',
                  'Pin de Protección',
                )}
              </NavLink>
            </li>
            <li className="menu-avatar-desktop__opt__admin">
              <NavLink to={history} onClick={() => sendMetric('Historial')}>
                {converter.convertApaUnicode(
                  translationsMetadata,
                  'my_history',
                  'Historial',
                )}
              </NavLink>
            </li>
            <li className="menu-avatar-desktop__opt__admin">
              <NavLink
                to={preference}
                onClick={() => sendMetric('Preferencias')}
              >
                {converter.convertApaUnicode(
                  translationsMetadata,
                  'preferences',
                  'Preferencias',
                )}
              </NavLink>
            </li>
          </>
        )}

        {!isKids && (
          <li
            className="menu-avatar-desktop__opt__admin"
            onClick={handleLogout}
          >
            <NavLink>
              {getTranslation('exit_btn_exit_txt', translations)}
            </NavLink>
          </li>
        )}
      </div>
    </>
  );
};
